import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

import { ThemeEnum } from "domain/customization/types"

export const Wrapp = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 80,
}))

export const ThemePalette = styled("div")<{ $theme: ThemeEnum }>(
  ({ $theme }) => ({
    padding: 24,
    borderRadius: 8,
    background: $theme === ThemeEnum.Dark ? palette.grey600 : palette.grey50,
    color: $theme === ThemeEnum.Dark ? palette.white : palette.black,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    minWidth: 150,
  })
)

export const FieldLabel = styled("div")(() => ({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: "20px",
  marginBottom: 4,
  fontStyle: "normal",
}))

export const FieldValueWrapp = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 4,
}))

export const FieldColor = styled("div")<{ $color: string }>(({ $color }) => ({
  minWidth: 32,
  minHeight: 32,
  borderRadius: "100%",
  border: `1px solid ${palette.grey200}`,
  backgroundColor: $color,
  boxSizing: "border-box",
}))

export const FieldInpWrapp = styled("div")(() => ({
  width: 100,
}))

export const WidgetPages = styled("div")(() => ({
  display: "flex",
  gap: 40,
  flexWrap: "wrap",
}))
